import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ListaAdminGrupoService } from './lista-admin-grupo.service';
import { HttpParams } from '@angular/common/http';
import { CommonService } from '../../../../shared/services/commom.service';
import { EncriptyUtilService } from '../../../../shared/services/encripty-util.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { DatatableService } from '../../../../shared/services/datatable.service';

@Component({
  selector: 'ngx-lista-admin-grupo',
  templateUrl: './lista-admin-grupo.component.html',
  styleUrls: ['./lista-admin-grupo.component.scss']
})
export class ListaAdminGrupoComponent implements OnInit, OnDestroy {

  public formListGrupo = null;
  rowData: any;
  open: any;
  public produtoId: any;

  private listProdutos: any = [];

  @ViewChild('myTable', null)
  public table: DatatableComponent;
  public customLogin = null;
  public listStatusGrupo = [
    { description: 'ATIVO', value: 'ATIVO' },
    { description: 'INATIVO', value: 'INATIVO' },
  ];

  constructor(

    private formBuilder: FormBuilder,
    private router: Router,
    private service: ListaAdminGrupoService,
    private route: ActivatedRoute,
    private commomService: CommonService,
    private encriptyService: EncriptyUtilService,
    private datatableService: DatatableService,
  ) {

  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.datatableService.subscribeTable(this.table);
    this.produtoId = this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-product-id'))

    this.formListGrupo = this.formBuilder.group({
      produtoId: [this.produtoId],
      descricao: [null],
      statusGrupo: '',
    });

    this.pesquisarGrupo(this.formListGrupo.value);
  }

  ngOnDestroy() {
    this.datatableService.unsubscribeTable(this.table)
  }

  opencadastro() {

    this.router.navigate(['/pages/gestao-user-terceiro/cadastro-admin-grupo']);

  }

  pesquisarGrupo(data: any) {

    let params: HttpParams = new HttpParams();
    if (data.produtoId != null && data.produtoId != '') {
      params = params.append('produtoId', data.produtoId);
    } else {
      params = params.append('produtoId', this.produtoId);
    }
    if (data.descricao != null && data.descricao != '') {
      params = params.append('descricao', data.descricao);
    }
    if (data.statusGrupo != null && data.statusGrupo != '') {
      params = params.append('statusPerfilAcesso', data.statusGrupo);
    }

    this.service.buscaGrupos(params)
      .subscribe(
        response => {
          this.rowData = response;
        }
      );
  }

  gotoEditMenus(data) {
    let grupoId = this.encriptyService.encriptyBySecretKey('' + data.id).toString();
    let descricao = this.encriptyService.encriptyBySecretKey('' + data.descricao).toString();
    let produtoNome = this.encriptyService.encriptyBySecretKey('' + data.produtoNome).toString();
    let produtoId = this.encriptyService.encriptyBySecretKey('' + data.produtoId).toString();
    let status = this.encriptyService.encriptyBySecretKey('' + data.status).toString();
    let params = { grupoId: grupoId, descricao: descricao, produtoId: produtoId, produtoNome: produtoNome, status: status };
    this.router.navigate(['../tela-grupo-menus'], { relativeTo: this.route, queryParams: params });
  }

  fillListProdutos() {
    return this.commomService.buscaProdutos()
      .subscribe(resp => this.listProdutos = resp);
  }

  limpar() {

    this.formListGrupo = this.formBuilder.group({
      produtoId: [null],
      descricao: [null],
      statusGrupo: '',
    });

    this.rowData = [];

  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

}
